import Cookies from "js-cookie";
import axios from "./config";
import qs from "qs";
import { jwtDecode } from "jwt-decode";
import { getHeader, getUserInfo } from '../../../utility/index';
interface DecodedToken {
  emp_id: string;
}


interface TerritoryListParams {
  search?: string;
  session_entity_key?: number | string;
}

export const getAllTerritory = async (
  page: number,
  size: number,
  params: TerritoryListParams = {}
): Promise<any> => {
  let url = "";
  if (params?.search)
    url = `/admin/territory-mappings?page=${page}&size=${size}&emp_id_search=${params.search}`;
  else url = `/admin/territory-mappings?page=${page}&size=${size}`;

  const payload: Record<string, number | string> = {};

  if (params?.session_entity_key) {
    payload.session_entity_key = params.session_entity_key;
  }

  const response = await axios.post<any>(
    url,
    payload,
    {
      headers: getHeader(),
    }
  );

  return response.data;
};


export const getDropdowns = async (
  sessionEntityKey?: string | number
): Promise<any> => {
  const url = `/admin/roadnet/territory-identifiers`;
  const params: Record<string, string | number> = {};
  if (sessionEntityKey) {
    params.session_entity_key = sessionEntityKey;
  }
  const response = await axios.get<any>(url, {
    headers: getHeader(),
    params,
  });
  return response.data;
};

export const getPlanningSessions = async (
  regionEntityKey?: string | number
): Promise<any> => {
  const url = `/admin/roadnet/planning-sessions`;
  const params: Record<string, string | number> = {};
  if (regionEntityKey) {
    params.region_entity_key = regionEntityKey;
  }
  const response = await axios.get<any>(url, {
    headers: getHeader(),
    params,
  });

  return response.data;
};

export const getRegions = async (): Promise<any> => {
  const url = `/admin/roadnet/regions`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });

  return response.data;
};

export const addNewTerritory = async (formData: any): Promise<any> => {
  let url = `/admin/territory-mappings/create`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};
export const updateTeri = async (
  formData: any,
  id: string
): Promise<any> => {
  const url = `/admin/territory-mappings/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );
  

  const response = await axios.put(url, cleanedPayload, {
    headers: {
      ...getHeader(),
      "Content-Type": "application/json",
    },
  });
  return response.data;
};


export const updateMonthly = async (
  formData: any,
  id: string
): Promise<any> => {
  const url = `/admin/employee-monthly-targets/${id}`;

  const cleanedPayload = Object.fromEntries(
    Object.entries(formData).filter(([_, v]) => v !== undefined)
  );

  const response = await axios.put(url, qs.stringify(cleanedPayload), {
    headers: {
      ...getHeader(),
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });

  return response.data;
};
export const getSpecificTeri = async (
  id: string,
): Promise<any> => {
  let url = `admin/territory-mappings/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const getSpecificMon = async (
  id: string,
): Promise<any> => {
  let url = `admin/employee-monthly-targets/${id}`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};
export const deleteTerritory = async (id: number): Promise<any> => {
  let url = `/admin/territory-mappings/${id}`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};

export const notificationSEND = async (formData: any): Promise<any> => {
  let url = `/admin/send_notification`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const createDummyTerritory = async (formData: {
  region_identifier: string;
  emp_id: number;
  territory_identifier: string;
}): Promise<any> => {
  const url = `/admin/dummy-territories`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const assignTerritoriesToEmployees = async (formData: any): Promise<any> => {
  const url = `/admin/lmd-territories/assign-territories-to-employees`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const assignSalesOffices = async (formData: any): Promise<any> => {
  const url = `/admin/lmd-territories/assign-sales-offices`;
  const response = await axios.post<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const listLmdTerritories = async (
  page: number,
  size: number,
  params: any = {}
): Promise<any> => {
  const url = `/admin/lmd-territories/details`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
    params: {
      page,
      size,
      ...params,
    },
  });
  return response.data;
};

export const removeEmployeeAssignments = async (formData: any): Promise<any> => {
  const url = `/admin/lmd-territories/remove-employee-assignments`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
    data: formData,
  });
  return response.data;
};

export const removeSalesOfficeAssignment = async (formData: any): Promise<any> => {
  const url = `/admin/lmd-territories/remove-sales-office-assignments`;
  const response = await axios.delete<any>(url, {
    headers: getHeader(),
    data: formData,
  });
  return response.data;
};

export const getLmdTerritoryDetails = async (territoryId: string | number): Promise<any> => {
  const url = `/admin/lmd-territories/details`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
    params: {
      territory_id: territoryId,
    },
  });
  return response.data;
};

export const updateLmdTerritoryEmployees = async (
  territoryId: string | number,
  formData: any
): Promise<any> => {
  const url = `/admin/lmd-territories/${territoryId}/employees`;
  const response = await axios.put<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const updateLmdTerritorySalesOffices = async (
  territoryId: string | number,
  formData: any
): Promise<any> => {
  const url = `/admin/lmd-territories/${territoryId}/sales-offices`;
  const response = await axios.put<any>(url, formData, {
    headers: getHeader(),
  });
  return response.data;
};

export const getEmployeeDetails = async (empId: string | number): Promise<any> => {
  const url = `/admin/lmd-territories/${empId}/employee-details`;
  const response = await axios.get<any>(url, {
    headers: getHeader(),
  });
  return response.data;
};